import React, { useState } from "react";
import Dropzone from "react-dropzone";

import {
  DropZoneStyled,
  DropZoneInner,
  DropZoneEmptyStateContainer,
  DropZoneEmptyStateIcon,
  DropZoneEmptyStateText,
  FormatTitleText,
  FormatText,
  FormatContainer,
  ErrorContainer,
  ErrorNotification,
  UploadDropzoneWrapper,
  UploadDropzoneContainer,
} from "../../UploadCsvDialog/UploadDropzone.style";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { useStaticDataQuery } from "../../../queries/useStaticDataQuery";
import { SyntheticEvent } from "hoist-non-react-statics/node_modules/@types/react";
import { displayWarningNotification } from "../../../redux/actions/_utils";

import { NotificationTypes } from "../../../_constant/NotificationTypes";
import { FileType, UploadErrorType } from "./WizardEditItemScreen";

import WizardMainFilesSection from "./WizardMainFileSection";

const ImageFileValidationOptions = {
  size: 10485760,
  type: ["image/jpeg", "image/png", "image/bmp", "image/gif"],
};

interface WizardUploadDropZoneProps {
  selectFile: (file: FileType) => void;
  file: FileType;
  uploadError: UploadErrorType;
  setUploadError: (uploadError: UploadErrorType) => void;
}

const WizardUploadDropZone: React.FC<WizardUploadDropZoneProps> = ({
  selectFile,
  file,
  uploadError,
  setUploadError,
  updateItem,
  newItem,
}) => {
  const staticData = useStaticDataQuery();
  const emptyStateIcon = staticData?.Icons?.Mobile?.pic_Mobile_Empty_State ?? "";

  const [isError, setIsError] = useState(false);

  const addFile = (acceptedFiles: File[]) => {
    setUploadError(null);
    const acceptedFile = acceptedFiles[0];
    if (acceptedFiles.length > 1) {
      displayWarningNotification(NotificationTypes.MORE_THEN_ONE_FILE);
    }
    if (
      ImageFileValidationOptions.type.includes(acceptedFile?.type) &&
      acceptedFile?.size < ImageFileValidationOptions.size
    ) {
      selectFile(acceptedFile);
      setIsError(false);
      updateItem({ ...newItem, Files: [acceptedFile] });
      return;
    }
    setIsError(true);
  };

  const removeFile = (e: SyntheticEvent) => {
    e.stopPropagation();
    selectFile(null);
    updateItem({ ...newItem, Files: [] });
  };

  return (
    <Dropzone
      onDrop={addFile}
      accept={ImageFileValidationOptions.type}
      maxSize={ImageFileValidationOptions.size}
    >
      {({ getRootProps, getInputProps }) => (
        <UploadDropzoneWrapper>
          <UploadDropzoneContainer {...getRootProps()}>
            <input {...getInputProps()} />
            <DropZoneInner>
              <DropZoneStyled>
                {!file ? (
                  <DropZoneEmptyStateContainer>
                    <DropZoneEmptyStateIcon src={emptyStateIcon} />

                    {!isError ? (
                      <>
                        <DropZoneEmptyStateText>
                          Upload an image of your item.
                        </DropZoneEmptyStateText>
                        <FormatContainer>
                          <FormatTitleText>Valid format:</FormatTitleText>
                          <FormatText>JPEG, PNG, JIF max 10 Mb</FormatText>
                        </FormatContainer>
                      </>
                    ) : (
                      <ErrorContainer>
                        <ErrorNotification>
                          <InfoOutlinedIcon /> Invalid format
                        </ErrorNotification>
                        <FormatContainer>
                          <FormatTitleText>Please check your file for compliance:</FormatTitleText>
                          <FormatText>JPEG, PNG, JFIF max 10 Mb</FormatText>
                        </FormatContainer>
                      </ErrorContainer>
                    )}
                  </DropZoneEmptyStateContainer>
                ) : (
                  <WizardMainFilesSection newItem={newItem} removeFile={removeFile} />
                )}
              </DropZoneStyled>
            </DropZoneInner>
          </UploadDropzoneContainer>
        </UploadDropzoneWrapper>
      )}
    </Dropzone>
  );
};

export default WizardUploadDropZone;
